export default "__VITE_ASSET__b0e11923__"